module.exports = __webpack_public_path__ + "img/hand-with-package.edde946.svg";